function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getInvoiceText, getInvoiceClassName } from '@/libs/customer';
import { approveApplyRevokeApi } from '@/api/business';
import { clientInvoiceDeleteApi, clientInvoiceListApi, accumulatedAmountApi, recallStatus, invalidApply, uninvoicedListApi } from '@/api/enterprise';
import { configRuleApproveApi } from '@/api/config';
export default {
  name: 'ContractInvoice',
  props: {
    formInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    contractInvoice: {
      type: String,
      default: ''
    }
  },
  components: {
    invoiceApply: function invoiceApply() {
      return import('@/components/invoice/invoiceApply');
    },
    markDialog: function markDialog() {
      return import('@/views/customer/contract/components/markDialog');
    },
    invoiceDetails: function invoiceDetails() {
      return import('@/components/invoice/invoiceDetails');
    },
    invoiceView: function invoiceView() {
      return import('@/views/customer/invoice/components/invoiceView');
    },
    mergeInvoice: function mergeInvoice() {
      return import('@/components/invoice/mergeInvoice');
    },
    editExamine: function editExamine() {
      return import('@/views/user/examine/components/editExamine');
    }
  },
  data: function data() {
    return {
      parameterData: {
        contract_id: '',
        customer_id: '',
        invoice_id: '',
        bill_id: ''
      },
      buildData: [],
      // 申请开票审批类型
      voidData: [],
      // 申请作废类型
      drawer: false,
      is_approval: false,
      // 判断是否开启审批流程
      mergeOpen: false,
      // 判断是否有付款单
      dialogVisible: false,
      cumulative_invoiced_price: '',
      audit_invoiced_price: '',
      cumulative_payment_price: '',
      direction: 'rtl',
      title: '',
      reason: '',
      form: {
        remarks: ''
      },
      rules: {
        remarks: [{
          required: true,
          message: '请填写撤回理由',
          trigger: 'blur'
        }]
      },
      tableData: [],
      where: {
        page: 1,
        limit: 15,
        types: ''
      },
      withdrawId: '',
      total: 0,
      formBoxConfig: {},
      configMark: {},
      isShow: true,
      invoiceData: {},
      commandId: 0 // 当前审批内容
    };
  },
  watch: {
    formInfo: {
      handler: function handler(nVal) {
        this.isShow = nVal.isClient === false;
        this.getConfigApprove();
        // this.getVoidData()
      },
      immediate: true,
      deep: true
    }
  },
  created: function created() {
    this.getConfigApprove();
  },
  methods: {
    // V1.4获取开票审批类型
    getConfigApprove: function getConfigApprove() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return configRuleApproveApi(0);
            case 2:
              result = _context.sent;
              _this.buildData = result.data;
              _this.is_approval = _this.buildData.invoicing_switch != 0 ? true : false;
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    getTableData: function getTableData() {
      var _this2 = this;
      this.accumulatedAmount();
      this.where.cid = this.formInfo.data.cid;
      this.parameterData.contract_id = this.formInfo.data.cid;
      this.where.eid = this.formInfo.data.eid;
      this.parameterData.customer_id = this.formInfo.data.eid;
      clientInvoiceListApi(this.where).then(function (res) {
        _this2.tableData = res.data.list;
        _this2.total = res.data.count;
      });
    },
    getAbnormal: function getAbnormal(row) {
      var isStatus = {
        0: row.mark || '暂无',
        2: row.mark || '暂无',
        3: row.card_remark || '暂无',
        4: row.card_remark || '暂无',
        5: row.finance_remark || '暂无',
        6: row.remark || '暂无'
      };
      return isStatus[row.status] || row.remark;
    },
    accumulatedAmount: function accumulatedAmount() {
      var _this3 = this;
      var data = {
        eid: this.formInfo.data.eid,
        cid: this.formInfo.data.cid
      };
      accumulatedAmountApi(data).then(function (res) {
        _this3.cumulative_invoiced_price = res.data.cumulative_invoiced_price;
        _this3.audit_invoiced_price = res.data.audit_invoiced_price;
        _this3.cumulative_payment_price = res.data.cumulative_payment_price;
      });
    },
    pageChange: function pageChange(val) {
      this.where.page = val;
      this.getTableData();
    },
    getInvoiceStatus: function getInvoiceStatus(status) {
      return getInvoiceText(status);
    },
    getInvoiceColor: function getInvoiceColor(status) {
      return getInvoiceClassName(status);
    },
    isOk: function isOk() {
      var _this4 = this;
      setTimeout(function () {
        _this4.getTableData();
      }, 300);
      this.$emit('handleInvoice');
    },
    // 发票撤回
    invoiceWithdrawal: function invoiceWithdrawal(val, type) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var id;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              id = type == 1 ? val.revoke_id : val.link_id;
              _context2.next = 3;
              return _this5.$modalSure('确认撤回该发票吗');
            case 3:
              _context2.next = 5;
              return approveApplyRevokeApi(id);
            case 5:
              _this5.getTableData();
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getApplyRevoke: function getApplyRevoke(id) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return approveApplyRevokeApi(id);
            case 2:
              _this6.getTableData();
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    // 作废撤回
    withdraw: function withdraw(val) {
      var _this7 = this;
      this.$modalSure(this.$t('customer.message08')).then(function () {
        var data = {
          invalid: -1
        };
        invalidApply(val.id, data).then(function (res) {
          _this7.getTableData();
        }).catch(function (error) {});
      });
    },
    // 申请作废
    apply: function apply(val) {
      this.title = '发票申请作废';
      this.reason = '作废原因';
      this.dialogVisible = true;
      this.withdrawId = val.id;
    },
    submitFn: function submitFn() {
      var _this8 = this;
      var data = {
        remark: this.form.remarks
      };
      if (this.title == '发票申请作废') {
        data.invalid = 1;
        invalidApply(this.withdrawId, data).then(function (res) {
          _this8.cancelFn();
          _this8.getTableData();
        });
      } else {
        recallStatus(this.withdrawId, data).then(function (res) {
          _this8.cancelFn();
          _this8.getTableData();
        });
      }
    },
    cancelFn: function cancelFn() {
      this.dialogVisible = false;
      this.form.remarks = '';
    },
    mergeOpenFn: function mergeOpenFn(val, type) {
      var _this9 = this;
      var data = null;
      return new Promise(function (resolve, reject) {
        if (type == '') {
          data = {
            eid: _this9.contractInvoice == 'is_contract' ? _this9.formInfo.data.eid : _this9.formInfo.data.id
          };
        } else {
          data = {
            eid: val.eid,
            invoice_id: val.id,
            withdraw: ''
          };
        }
        uninvoicedListApi(data).then(function (res) {
          if (JSON.stringify(res.data) == '[]') {
            _this9.mergeOpen = false;
          } else {
            _this9.mergeOpen = true;
          }
          resolve(_this9.mergeOpen);
        });
      });
    },
    // V1.4获取申请开票表单
    handleBuild: function handleBuild(command, val, type) {
      if (type === 'void_invoice_switch') {
        this.parameterData.invoice_id = command.id;
        this.$refs.editExamine.openBox(val, command, type);
      } else {
        this.opneApply(1, '', val);
      }
    },
    // 申请开票
    opneApply: function opneApply(val, type, id) {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (type == '') {
                _this10.mergeOpenFn(val, type).then(function () {
                  _this10.formBoxConfig = {
                    title: '申请开票',
                    width: '1000px',
                    edit: false,
                    data: _this10.formInfo.data,
                    type: type
                  };
                  if (_this10.mergeOpen) {
                    _this10.$refs.mergeInvoice.openBox(id);
                  } else {
                    if (id > 0) {
                      _this10.parameterData.contract_id = _this10.formInfo.data.cid;
                      _this10.parameterData.customer_id = _this10.formInfo.data.eid;
                      _this10.parameterData.invoice_id = '';
                      _this10.$refs.editExamine.openBox(id);
                    } else {
                      _this10.$refs.invoiceApply.openBox();
                    }
                  }
                });
              } else {
                _this10.mergeOpenFn(val, type).then(function () {
                  if (_this10.mergeOpen) {
                    _this10.formBoxConfig = {
                      title: '编辑发票申请',
                      width: '1000px',
                      edit: true,
                      rowData: val,
                      data: _this10.formInfo.data,
                      type: type
                    };
                    _this10.$refs.mergeInvoice.openBox();
                  } else {
                    _this10.formBoxConfig = {
                      title: '编辑发票申请',
                      width: '1000px',
                      edit: true,
                      data: _this10.formInfo.data,
                      rowData: val
                    };
                    if (_this10.buildData.length > 0) {
                      _this10.$refs.editExamine.openBox(_this10.commandId);
                    } else {
                      _this10.$refs.invoiceApply.openBox(val.id);
                    }
                  }
                });
              }
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    handleEdit: function handleEdit(row) {
      this.formBoxConfig = {
        title: this.$t('customer.invoiceedit'),
        width: '820px',
        edit: true,
        data: row
      };
      this.$refs.invoiceApply.openBox();
    },
    handleCheck: function handleCheck(row) {
      this.invoiceData = {
        title: '发票查看',
        width: '1000px',
        data: row
      };
      if (row.link_id == 0) {
        this.$refs.invoiceView.openBox(row.link_id);
      } else {
        this.$refs.invoiceDetailsView.openBox(row.link_id);
      }
    },
    setRemarks: function setRemarks(row) {
      this.configMark = {
        title: this.$t('customer.remarkinformation'),
        width: '480px',
        id: row.id,
        type: 2,
        mark: row.mark
      };
      this.$refs.markDialog.handleOpen();
    },
    // 删除
    handleDelete: function handleDelete(item) {
      var _this11 = this;
      this.$modalSure(this.$t('customer.placeholder23')).then(function () {
        clientInvoiceDeleteApi(item.id).then(function (res) {
          if (_this11.where.page > 1 && _this11.tableData.length <= 1) {
            _this11.where.page--;
          }
          _this11.isOk();
        });
      });
    }
  }
};